// ABOUTME: Reads the current admin panel user's role from the auth store.
import { useAuthStore } from '../store/authStore';

export function useCurrentRole() {
  return useAuthStore((state) => state.user?.role);
}

export function useIsSuperAdmin() {
  return useCurrentRole() === 'super_admin';
}
